import { render, staticRenderFns } from "./OxHtmlArea.vue?vue&type=template&id=c46c7576&"
import script from "./OxHtmlArea.vue?vue&type=script&lang=js&"
export * from "./OxHtmlArea.vue?vue&type=script&lang=js&"
import style0 from "./OxHtmlArea.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports